import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/orders/')({
  loader: () => {
    throw redirect({
      to: '/orders/missing',
    })
  },
})
